export const hourlyCalendar = {
  title: "Calendario por horas",
  navSubtitle: "Venta por horas de tu hotel",
  hotel: "Hotel",
  rooms: "Habitaciones",
  roomsAbbr: "hab",
  noDisp: "No disp.",
  footer: {
    free: "{n} libres",
    occupied: "{n} ocupadas",
    cleaning: "{n} en limpieza",
    timezone: "Zona horaria: {tz}",
  },
  today: "Hoy",
  prevDay: "Día anterior",
  nextDay: "Día siguiente",
  newStay: "Nueva estancia",
  settingsBtn: "Ajustes de la venta por horas",
  retry: "Reintentar",
  dragHint: "Arrastra sobre una habitación para crear una estancia",
  groupFree: "{free} de {total} libres",
  zoom: { label: "Zoom", compact: "Compacta", normal: "Normal", wide: "Amplia" },
  duration: { min: "{n} min", h: "{n} h", hmin: "{h} h {m} min" },
  kpi: {
    free: "Libres ahora",
    occupied: "Ocupadas",
    cleaning: "En limpieza",
    arrivals: "Llegan en 1 h",
    overdueAlert: "1 habitación se ha pasado de hora | {n} habitaciones se han pasado de hora",
  },
  state: {
    free: "Libre",
    freeNext: "Libre · próxima {time}",
    soon: "Llega a las {time}",
    occupied: "Ocupada",
    occupiedLeft: "Ocupada · quedan {time}",
    overdue: "Se pasó {time}",
    due: "Esperando entrada",
    cleaning: "Limpieza · {time}",
    closed: "Cerrada",
    maintenance: "Fuera de servicio",
  },
  status: {
    booked: "Reservada",
    in_house: "En curso",
    checked_out: "Finalizada",
    cancelled: "Cancelada",
    no_show: "No se presentó",
  },
  block: {
    noName: "Sin nombre",
    blocked: "Bloqueada",
    night: "Noche",
    closed: "Cerrada",
    maintenance: "Fuera de servicio",
    left: "Quedan {time}",
  },
  legend: {
    booked: "Reservada",
    inHouse: "En curso",
    overdue: "Se pasó de hora",
    cleaning: "Limpieza",
    night: "Reserva por noche",
    closed: "Cerrada",
  },
  rangeMenu: {
    create: "Crear estancia",
    createSub: "En el horario seleccionado",
    block: "Bloquear este horario",
    blockSub: "La habitación no se vende en ese rango",
    closeDay: "Cerrar la habitación todo el día",
    closeDaySub: "Ese día no se vende esta habitación",
  },
  blockMenu: {
    editReason: "Cambiar el motivo",
    editReasonSub: "Se ve en el calendario",
    remove: "Quitar el bloqueo",
    removeSub: "La habitación vuelve a venderse",
  },
  blockModal: {
    titleRange: "Bloquear este horario",
    titleDay: "Cerrar la habitación",
    titleEdit: "Motivo del bloqueo",
    msgRange: "{room} no se venderá de {range}.",
    msgDay: "{room} no se venderá el {date}.",
    msgDayRest: "{room} no se venderá el resto del día (desde las {time}).",
    msgEdit: "{room}",
    reasonLabel: "Motivo",
    reasonHint: "(se ve en el calendario)",
    placeholder: "Mantenimiento, uso propio…",
    cancel: "Cancelar",
    block: "Bloquear",
    save: "Guardar",
    presetMaintenance: "Mantenimiento",
    presetOwner: "Uso del propietario",
    presetRepair: "Reforma",
    presetDeepClean: "Limpieza a fondo",
    presetClosed: "Cerrada",
  },
  drawer: {
    close: "Cerrar",
    closeBtn: "Cerrar",
    newTitle: "Nueva estancia",
    newPill: "Nueva",
    when: "Cuándo",
    room: "Habitación",
    start: "Entrada",
    end: "Salida",
    nextDay: "día siguiente",
    duration: "Duración",
    other: "Otra",
    free: "Habitación libre en ese horario",
    freeWithCleaning: "Libre · se guardan {n} min para limpiar al salir",
    freeWillClose: "Libre · luego se queda cerrada hasta las {hour}",
    busy: "Ocupada de {from} a {to}",
    busyClosed: "Cerrada de {from} a {to}",
    busyMaintenance: "Habitación fuera de servicio",
    guest: "Cliente",
    guestName: "Nombre",
    phone: "Teléfono",
    optional: "Opcional",
    guests: "Personas",
    charge: "Cobro",
    price: "Precio",
    method: "Forma de pago",
    methods: { cash: "Efectivo", card: "Tarjeta", transfer: "Transferencia", other: "Otro" },
    paid: "Cobrado",
    paidHint: "Ya tienes el dinero de esta estancia.",
    notes: "Notas",
    notesPh: "Matrícula, peticiones, lo que haga falta",
    guestTitle: "Registro del huésped",
    sendCheckin: "Enviar enlace de check-in",
    sendCheckinHint: "Se envía al guardar, al teléfono del huésped.",
    sendCheckinNoPhone: "Escribe el teléfono del huésped para poder mandarle el check-in.",
    doCheckin: "Hacer check-in",
    edit: "Editar",
    client: "Cliente",
    paidYes: "Cobrado",
    paidNo: "Sin cobrar",
    markPaid: "Marcar como cobrado",
    doCheckinHint: "Ábrelo en el móvil del huésped o pásale el enlace: nombre, apellidos y documento, con escáner si quiere.",
    copyLink: "Copiar enlace",
    copied: "Enlace copiado",
    checkinDone: "Check-in hecho · {n} huésped registrado | Check-in hecho · {n} huéspedes registrados",
    checkinErrors: {
      no_reservation: "Enciende «Registrar las estancias como reservas» en los ajustes para poder pedir el check-in.",
      no_phone: "Escribe el teléfono del huésped para poder mandárselo.",
      send_failed: "No se pudo enviar. Prueba a copiar el enlace y pasárselo tú.",
      not_requested: "No se pudo enviar. Prueba a copiar el enlace y pasárselo tú.",
    },
    checkinSent: "Check-in enviado",
    sendCheckinFailed: "No se pudo enviar el check-in. Revisa el teléfono del huésped.",
    save: "Guardar",
    saveAndIn: "Guardar y registrar entrada",
    saveChanges: "Guardar cambios",
    checkIn: "Registrar entrada",
    checkOut: "Registrar salida",
    extend30: "30 min",
    extend60: "1 h",
    extendOther: "Otro",
    extendHow: "Alargar",
    extendApply: "Alargar",
    cancelBtn: "Cancelar",
    checkOutNotYet: "Se podrá registrar la salida cuando empiece la estancia",
    confirmEarlyOutTitle: "La estancia aún no ha empezado",
    confirmEarlyOut: "Esta estancia empieza más tarde. Si registras la salida ahora se cierra y la habitación queda libre. Si el cliente no ha venido, usa «No se presentó».",
    noShow: "No se presentó",
    cancelStay: "Cancelar estancia",
    keep: "Volver",
    confirmCancel: "Se anula y la habitación queda libre en ese horario. No se puede deshacer.",
    confirmNoShow: "La franja vuelve a quedar libre para vender. Queda anotado que el cliente no vino.",
    confirmNoShowInHouse: "Figuraba dentro, pero no llegó a subir: se deshace la entrada y la franja vuelve a quedar libre.",
    confirmCancelInHouse: "Figuraba dentro: se deshace la entrada, se anula la estancia y la habitación queda libre. No se puede deshacer.",
    confirmNoShowTitle: "¿No se presentó?",
    confirmCancelTitle: "¿Cancelar la estancia?",
    remaining: "Quedan {time}",
    overdue: "Se ha pasado {time} de su hora",
    startsIn: "Empieza en {time}",
    waiting: "Su hora ya empezó: esperando la entrada",
    closedInfo: "Estancia cerrada: solo se pueden cambiar el cobro y las notas.",
    night: {
      title: "Reserva por noches",
      dates: "Del {from} al {to}",
      code: "Código",
      channel: "Canal",
      hint: "Las reservas por noches se gestionan desde el calendario de hotel. Aquí se ven para que ninguna estancia por horas se cruce con ellas.",
      open: "Ir al calendario de hotel",
    },
  },
  settings: {
    title: "Venta por horas",
    enable: "Vender por horas",
    subtitle: "Cómo se vende por horas en este hotel",
    offTitle: "Si la apagas",
    offBody: "El calendario por horas deja de estar disponible y el hotel vuelve a funcionar como siempre. Nada se borra.",
    offBodyStays: "Tienes {n} estancias por horas próximas: no se borran, pero dejarás de verlas hasta que la vuelvas a activar.",
    enabledOn: "Activada: el calendario por horas está en uso",
    enabledOff: "Desactivada",
    requirements: "Requisitos",
    req: {
      rooms: "Habitaciones creadas ({n})",
      channels: "Sin canales de venta conectados",
      ical: "Sin calendarios iCal sincronizados",
      web: "Reserva por la web desactivada",
      nights: "{n} reservas por noches futuras: se verán en el calendario y bloquearán sus habitaciones",
    },
    reqWhy: "Los canales, el iCal y la web venden noches y no saben nada de horas: con cualquiera de ellos encendido se podría vender la misma habitación dos veces.",
    cleaning: "Limpieza entre estancias",
    cleaningHint: "Se reserva automáticamente después de cada salida.",
    pending: "Pendiente de limpieza",
    pendingHint: "Al salir un cliente, la habitación se marca «por limpiar» en Limpieza y en la app durante este tiempo. NO bloquea la venta: si entra alguien antes, la limpias y ya.",
    none: "ninguna",
    minutes: "min",
    hours: "h",
    closeTitle: "Cerrar hasta la hora de apertura",
    closeHint: "Para cuando no se limpia en el momento: la habitación se queda cerrada y nadie puede venderla hasta que abras.",
    closeAfterStay: "Al terminar una estancia, dejar la habitación cerrada",
    closeAfterStayHint: "Se cierra sola hasta la hora de apertura del día siguiente. Si la limpias antes, pulsa «Ya está limpia» y vuelve a venderse al momento.",
    afterTitle: "Después de cada estancia",
    afterHint: "Cuánto tiempo deja de venderse la habitación cuando sale un cliente.",
    untilOpening: "Hasta la apertura",
    reopenHour: "Hora de apertura de la venta",
    reopenNote: "Las habitaciones sucias vuelven a venderse a las {hour}.",
    markClean: "Ya está limpia",
    markCleanHint: "Abre la habitación ahora, sin esperar a la hora de apertura.",
    closeThisStay: "Dejar la habitación cerrada al terminar",
    closeThisStayHint: "No se podrá vender hasta las {hour}. La hora, en Ajustes.",
    dayStart: "Inicio del día del calendario",
    dayRange: "de {from} a {from} del día siguiente",
    dayStartHint: "Elige la hora de menos movimiento: así la noche se ve entera, sin cortes.",
    quickHours: "Duraciones rápidas",
    quickHoursHint: "Aparecen como atajos al crear una estancia (hasta 6).",
    guestTitle: "Registro del huésped",
    asReservation: "Registrar las estancias como reservas",
    asReservationHint: "Cada estancia crea su reserva: así el dinero aparece en tus informes y puedes pedir el check-in y el parte de viajeros. Si lo apagas, las ventas por horas no se sumarán a tus ingresos.",
    checkinDefault: "Pedir el check-in por defecto",
    checkinDefaultHint: "El interruptor de la ficha de la estancia vendrá encendido.",
    guestHint: "Estas reservas no reciben los avisos pensados para noches (bienvenida, llegada, salida ni reseña): el enlace de check-in se manda cuando tú lo pides.",
    save: "Guardar ajustes",
    saved: "Ajustes guardados",
  },
  empty: {
    eyebrow: "Venta por horas",
    title: "Vende tus habitaciones por horas",
    body: "Un calendario pensado para moteles y hoteles de estancias cortas: ves cada habitación al minuto, creas estancias arrastrando y la limpieza entre una y otra se reserva sola.",
    point1: "Estado de cada habitación en tiempo real",
    point2: "Arrastra para crear, mover o alargar estancias",
    point3: "Limpieza entre estancias, automática",
    cta: "Activar venta por horas",
    ctaBlocked: "Completa los requisitos para activarla",
    noHotelsTitle: "Aún no tienes un hotel",
    noHotels: "La venta por horas funciona con alojamientos de tipo hotel que tengan habitaciones creadas.",
  },
  guide: {
    open: "Manual de uso",
    title: "Cómo funciona el calendario por horas",
    subtitle: "Lo esencial en un minuto: crear estancias, registrar entradas y salidas, y cerrar habitaciones cuando no se venden.",
    createTitle: "Crear una estancia",
    createBody: "Arrastra sobre la fila de la habitación, desde la hora de entrada hasta la de salida. También puedes pulsar «Nueva estancia» y escribir las horas a mano.",
    moveTitle: "Mover y alargar",
    moveBody: "Arrastra la barra para cambiarla de hora o de habitación. Tirando del borde derecho alargas o acortas la estancia. Si el hueco está ocupado, el calendario no te deja soltarla.",
    checkinTitle: "Entrada y salida",
    checkinBody: "Abre la estancia y registra la entrada cuando llegue el huésped y la salida cuando se vaya. Si se pasa de la hora, la barra se pone roja con los minutos de más.",
    cleaningTitle: "Limpieza entre estancias",
    cleaningBody: "Después de cada salida se reserva sola la franja de limpieza que hayas configurado. Nadie puede entrar en ese rato.",
    blockTitle: "Bloquear un horario o cerrar la habitación",
    blockBody: "Selecciona un rango y elige «Bloquear este horario», o «Cerrar la habitación todo el día» si ese día no la vas a vender. Puedes cambiar el motivo o quitarlo pulsando sobre el bloqueo.",
    settingsTitle: "Ajustes",
    settingsBody: "En el engranaje configuras el tiempo de limpieza, la hora en la que empieza el día del calendario y las duraciones rápidas que ves al crear una estancia.",
    colorsTitle: "Qué significa cada color",
    colors: {
      booked: "Creada, el huésped aún no ha entrado",
      inHouse: "El huésped está dentro",
      overdue: "Pasada la hora de salida",
      cleaning: "Franja reservada para limpiar",
      night: "Viene del calendario por noches",
      closed: "Bloqueada o cerrada a mano",
    },
    otasTitle: "Reservas por noches y canales",
    otasBody: "Las reservas por noches se ven aquí para que sepas qué habitaciones están ocupadas, pero se gestionan en el calendario del hotel. Mientras vendas por horas, este alojamiento no se conecta a las OTAs.",
    gotIt: "Entendido",
  },
  toasts: {
    created: "Estancia creada",
    checkedIn: "Entrada registrada",
    checkedOut: "Salida registrada · limpieza en marcha",
    updated: "Cambios guardados",
    extended: "Estancia alargada",
    cancelled: "Estancia cancelada",
    noShow: "Marcada como no presentada",
    moved: "Estancia movida",
    resized: "Duración actualizada",
    activated: "Venta por horas activada",
    blocked: "Horario bloqueado",
    blockUpdated: "Motivo actualizado",
    blockRemoved: "Bloqueo quitado",
    loadError: "No se pudo cargar el calendario por horas",
    error: "No se pudo guardar. Inténtalo de nuevo.",
  },
  errors: {
    room_busy: "La habitación está ocupada de {from} a {to}",
    hourly_disabled: "La venta por horas no está activada en este hotel.",
    room_maintenance: "Esa habitación está fuera de servicio.",
    room_not_found: "Esa habitación no es de este hotel.",
    invalid_duration: "La duración tiene que estar entre 30 minutos y 48 horas.",
    invalid_start: "La hora de entrada no es válida.",
    stay_closed: "Esta estancia ya está cerrada: no se puede mover.",
    invalid_status: "Esa acción no se puede hacer en el estado actual de la estancia.",
    requirements_not_met: "Este hotel aún no cumple los requisitos para vender por horas.",
    not_found: "No se encontró lo que buscas. Recarga la página.",
    generic: "Algo ha fallado. Inténtalo de nuevo.",
  },
};
